import { useMutation, useQuery } from '@tanstack/react-query';
import discountCodesService from '../services/discountCodesService';

export const useDeleteMultipleDiscountCodes = () => {
	return useMutation({
		mutationKey: ['discountCodes'],
		mutationFn: (data: DeleteMultipleDiscountCodesRequest[]) =>
			discountCodesService.deleteMultipleDiscountCodes(data),
	});
};

export const useGetSingleDiscountCode = (
	discountCodeID: number,
	options?: { isEnabled?: boolean },
) => {
	return useQuery<DiscountCode>({
		queryKey: ['discountCode', discountCodeID],
		queryFn: () => discountCodesService.getSingleResource(discountCodeID),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useGetAllDiscountCodes = (options?: {
	filters?: string;
	isEnabled?: boolean;
}) => {
	return useQuery<TavoittajaApiResponse<{ discountCodes: DiscountCode[] }>>({
		queryKey: ['discountCodes'],
		queryFn: () =>
			discountCodesService.getAllResources({
				filters: options?.filters,
			}),
		enabled: options?.isEnabled === false ? false : true,
	});
};

export const useDeleteDiscountCode = () => {
	return useMutation({
		mutationKey: ['discountCodes'],
		mutationFn: (id: number) =>
			discountCodesService.deleteSingleResource(id),
	});
};

export const useUpdateDiscountCode = () => {
	return useMutation({
		mutationKey: ['discountCodeUpdate'],
		mutationFn: (data: Partial<UpdateDiscountCodeRequest>) =>
			discountCodesService.update(data),
	});
};

export const useAddDiscountCode = () => {
	return useMutation({
		mutationKey: ['discountCode'],
		mutationFn: (data: AddDiscountCodeRequest) =>
			discountCodesService.create(data),
	});
};
